// Module
var code = "<div class=\"vui-landing-page-header-item\">\n    <ng-transclude></ng-transclude>\n</div>\n";
// Exports
module.exports = code;